module.exports = __webpack_public_path__ + "static/media/refresh-img.c380adb8.svg";